// Native American Warriors Data - Group Four (Pacific Northwest & Strategic Masters)

// Chief Joseph's workout programs
const chiefJosephPrograms = [
    {
        id: 'strategic-retreat-training',
        name: 'Strategic Retreat Training',
        description: 'Masterful tactical withdrawal conditioning while protecting non-combatants',
        pattern: 'fa@wd',
        reps: 16,
        sets: 4,
        focus: 'Strategic Withdrawal'
    },
    {
        id: 'nez-perce-dignity-conditioning',
        name: 'Nez Perce Dignity Conditioning',
        description: 'Noble leadership training that maintains honor even in impossible circumstances',
        pattern: '@wfad',
        reps: 14,
        sets: 4,
        focus: 'Noble Dignity'
    },
    {
        id: 'pacific-northwest-workout',
        name: 'Pacific Northwest Workout',
        description: 'Mountain and valley conditioning in the beautiful but challenging Northwest terrain',
        pattern: 'wa@fd',
        reps: 18,
        sets: 3,
        focus: 'Northwest Endurance'
    },
    {
        id: 'thousand-mile-protocol',
        name: 'Thousand Mile Protocol',
        description: 'Epic endurance training for the legendary fighting retreat across multiple states',
        pattern: 'f@wad',
        reps: 20,
        sets: 3,
        focus: 'Epic Endurance'
    },
    {
        id: 'chief-compassion-training',
        name: 'Chief Compassion Training',
        description: 'Leadership conditioning that balances warrior strength with protective compassion',
        pattern: 'adf@w',
        reps: 12,
        sets: 5,
        focus: 'Compassionate Leadership'
    },
    {
        id: 'tragic-hero-mastery',
        name: 'Tragic Hero Mastery',
        description: 'Complete mastery for a leader whose nobility shines brightest in defeat',
        pattern: 'fa@wd!',
        reps: 22,
        sets: 3,
        focus: 'Tragic Nobility'
    }
];

// Looking Glass's workout programs
const lookingGlassPrograms = [
    {
        id: 'nez-perce-tactician-training',
        name: 'Nez Perce Tactician Training',
        description: 'Advanced tactical conditioning from one of the finest Native American military minds',
        pattern: '@fwad',
        reps: 17,
        sets: 3,
        focus: 'Tactical Brilliance'
    },
    {
        id: 'mountain-warfare-conditioning',
        name: 'Mountain Warfare Conditioning',
        description: 'High-altitude combat training in the rugged Idaho and Montana mountains',
        pattern: 'faw@d',
        reps: 19,
        sets: 3,
        focus: 'Mountain Combat'
    },
    {
        id: 'battlefield-genius-workout',
        name: 'Battlefield Genius Workout',
        description: 'Tactical intelligence training for warriors who can read terrain like a book',
        pattern: 'wa@df',
        reps: 15,
        sets: 4,
        focus: 'Tactical Intelligence'
    },
    {
        id: 'mounted-commander-protocol',
        name: 'Mounted Commander Protocol',
        description: 'Cavalry leadership conditioning for directing complex mounted operations',
        pattern: '@fawd',
        reps: 21,
        sets: 3,
        focus: 'Cavalry Command'
    },
    {
        id: 'warriors-last-stand-training',
        name: 'Warrior\'s Last Stand Training',
        description: 'Final battle conditioning for those who die fighting rather than surrender',
        pattern: 'fad@w',
        reps: 13,
        sets: 5,
        focus: 'Final Stand'
    },
    {
        id: 'military-genius-mastery',
        name: 'Military Genius Mastery',
        description: 'Ultimate training for one of the greatest Native American tactical minds',
        pattern: '@fwad!',
        reps: 24,
        sets: 3,
        focus: 'Military Genius'
    }
];

// Kamiakin's workout programs
const kamiakinPrograms = [
    {
        id: 'yakama-diplomat-training',
        name: 'Yakama Diplomat Training',
        description: 'Balanced conditioning combining diplomatic skills with warrior readiness',
        pattern: 'fa@wd',
        reps: 14,
        sets: 4,
        focus: 'Diplomatic Warrior'
    },
    {
        id: 'columbia-river-conditioning',
        name: 'Columbia River Conditioning',
        description: 'River valley strength training along the mighty Columbia River corridor',
        pattern: '@wfad',
        reps: 16,
        sets: 4,
        focus: 'River Valley Power'
    },
    {
        id: 'plateau-leader-workout',
        name: 'Plateau Leader Workout',
        description: 'High plateau conditioning for leading diverse Plateau tribes',
        pattern: 'waf@d',
        reps: 18,
        sets: 3,
        focus: 'Plateau Leadership'
    },
    {
        id: 'treaty-negotiator-protocol',
        name: 'Treaty Negotiator Protocol',
        description: 'Diplomatic strength training for those who must negotiate from positions of power',
        pattern: 'f@wad',
        reps: 11,
        sets: 5,
        focus: 'Treaty Power'
    },
    {
        id: 'regional-alliance-training',
        name: 'Regional Alliance Training',
        description: 'Multi-tribal coordination conditioning across the diverse Northwest territories',
        pattern: 'afw@d',
        reps: 20,
        sets: 3,
        focus: 'Regional Unity'
    },
    {
        id: 'plateau-chief-mastery',
        name: 'Plateau Chief Mastery',
        description: 'Complete mastery for a leader who united the diverse Plateau peoples',
        pattern: 'fa@wd!',
        reps: 19,
        sets: 3,
        focus: 'Plateau Mastery'
    }
];

// Leschi's workout programs
const leschiPrograms = [
    {
        id: 'nisqually-defender-training',
        name: 'Nisqually Defender Training',
        description: 'Puget Sound defense conditioning for protecting coastal homelands',
        pattern: '@fawd',
        reps: 15,
        sets: 4,
        focus: 'Coastal Defense'
    },
    {
        id: 'puget-sound-conditioning',
        name: 'Puget Sound Conditioning',
        description: 'Coastal warrior training in the forests and waters of Puget Sound',
        pattern: 'wf@ad',
        reps: 17,
        sets: 3,
        focus: 'Coastal Warrior'
    },
    {
        id: 'territorial-resistance-workout',
        name: 'Territorial Resistance Workout',
        description: 'Regional resistance conditioning against territorial government encroachment',
        pattern: 'afw@d',
        reps: 19,
        sets: 3,
        focus: 'Territorial Resistance'
    },
    {
        id: 'mount-rainier-protocol',
        name: 'Mount Rainier Protocol',
        description: 'High mountain conditioning in the shadow of the great Mount Rainier',
        pattern: 'f@awd',
        reps: 21,
        sets: 3,
        focus: 'Mountain Shadow'
    },
    {
        id: 'sacrificial-leader-training',
        name: 'Sacrificial Leader Training',
        description: 'Noble sacrifice conditioning for leaders who give everything for their people',
        pattern: 'wafd@',
        reps: 12,
        sets: 5,
        focus: 'Noble Sacrifice'
    },
    {
        id: 'martyr-chief-mastery',
        name: 'Martyr Chief Mastery',
        description: 'Ultimate training for a leader who became a martyr for his people\'s rights',
        pattern: '@fawd!',
        reps: 18,
        sets: 3,
        focus: 'Martyred Leadership'
    }
];

// Little Turtle's workout programs
const littleTurtlePrograms = [
    {
        id: 'miami-strategist-training',
        name: 'Miami Strategist Training',
        description: 'Brilliant tactical conditioning from the greatest Native American military strategist',
        pattern: 'ta@wd',
        reps: 18,
        sets: 3,
        focus: 'Strategic Brilliance'
    },
    {
        id: 'great-lakes-general-conditioning',
        name: 'Great Lakes General Conditioning',
        description: 'Regional command training across the vast Great Lakes territories',
        pattern: '@wtad',
        reps: 16,
        sets: 4,
        focus: 'Regional Command'
    },
    {
        id: 'fallen-timbers-workout',
        name: 'Fallen Timbers Workout',
        description: 'Major battle conditioning commemorating victories and learning from defeats',
        pattern: 'wa@td',
        reps: 20,
        sets: 3,
        focus: 'Battle Experience'
    },
    {
        id: 'turtle-wisdom-protocol',
        name: 'Turtle Wisdom Protocol',
        description: 'Patient strategic conditioning that builds slowly but becomes unbeatable',
        pattern: 't@wad',
        reps: 14,
        sets: 4,
        focus: 'Patient Strategy'
    },
    {
        id: 'peace-transition-training',
        name: 'Peace Transition Training',
        description: 'Wisdom-based conditioning for leaders who know when to fight and when to make peace',
        pattern: 'adt@w',
        reps: 11,
        sets: 5,
        focus: 'Wisdom Transition'
    },
    {
        id: 'strategic-master-mastery',
        name: 'Strategic Master Mastery',
        description: 'Ultimate training for the most brilliant Native American military strategist',
        pattern: 'ta@wd!',
        reps: 22,
        sets: 3,
        focus: 'Strategic Mastery'
    }
];

// Osceola's workout programs
const osceolaPrograms = [
    {
        id: 'seminole-swamp-training',
        name: 'Seminole Swamp Training',
        description: 'Everglades conditioning for warfare in the unique Florida wetland environment',
        pattern: 'ia@wd',
        reps: 17,
        sets: 3,
        focus: 'Swamp Warfare'
    },
    {
        id: 'everglades-guerrilla-conditioning',
        name: 'Everglades Guerrilla Conditioning',
        description: 'Wetland guerrilla training using the Everglades as an impenetrable fortress',
        pattern: '@wiad',
        reps: 19,
        sets: 3,
        focus: 'Wetland Guerrilla'
    },
    {
        id: 'young-chief-workout',
        name: 'Young Chief Workout',
        description: 'Youthful energy conditioning channeled into brilliant leadership and defiance',
        pattern: 'wa@id',
        reps: 21,
        sets: 3,
        focus: 'Youthful Defiance'
    },
    {
        id: 'florida-resistance-protocol',
        name: 'Florida Resistance Protocol',
        description: 'Regional resistance conditioning in the challenging Florida environment',
        pattern: 'i@wad',
        reps: 15,
        sets: 4,
        focus: 'Florida Resistance'
    },
    {
        id: 'unconquered-spirit-training',
        name: 'Unconquered Spirit Training',
        description: 'Unbreakable will conditioning for those who never surrender or give up',
        pattern: 'adi@w',
        reps: 23,
        sets: 3,
        focus: 'Unconquered Will'
    },
    {
        id: 'swamp-legend-mastery',
        name: 'Swamp Legend Mastery',
        description: 'Ultimate training for the legendary young chief who mastered swamp warfare',
        pattern: 'ia@wd!',
        reps: 25,
        sets: 3,
        focus: 'Swamp Legend'
    }
];

// Main Native American warriors data object - Group Four
const nativeAmericanFourTrainersData = {
    'chief-joseph': {
        id: 'chief-joseph',
        name: 'Chief Joseph',
        specialization: 'Strategic Retreat & Noble Leadership',
        image: '/assets/images/Chief-Joseph.jpg',
        experience: '64+ years',
        category: 'native-american',
        color: '#4169E1',
        secondaryColor: '#C0C0C0',
        intro: `The Nez Perce leader who conducted one of the greatest fighting retreats in military history, Chief Joseph combined tactical brilliance with noble compassion. His training develops the strategic endurance needed for long campaigns while maintaining the moral strength to protect non-combatants. Students learn that true leadership means shouldering impossible burdens with dignity.`,
        programs: chiefJosephPrograms
    },
    'looking-glass': {
        id: 'looking-glass',
        name: 'Looking Glass',
        specialization: 'Tactical Genius & Mountain Warfare',
        image: '/assets/images/Looking-Glass.jpg',
        experience: '45+ years',
        category: 'native-american',
        color: '#2F4F4F',
        secondaryColor: '#C0C0C0',
        intro: `The Nez Perce war chief whose tactical brilliance made him nearly unbeatable in mountain warfare, Looking Glass could read terrain like a book and predict enemy movements. His training develops the sharp tactical intelligence and mountain conditioning needed for complex military operations in challenging terrain.`,
        programs: lookingGlassPrograms
    },
    'kamiakin': {
        id: 'kamiakin',
        name: 'Kamiakin',
        specialization: 'Diplomatic Warfare & Regional Unity',
        image: '/assets/images/Kamiakin.jpg',
        experience: '70+ years',
        category: 'native-american',
        color: '#8B4513',
        secondaryColor: '#C0C0C0',
        intro: `The Yakama chief who united diverse Plateau tribes and skillfully balanced diplomacy with warfare, Kamiakin understood that lasting strength comes from building alliances. His training develops the diplomatic intelligence and regional coordination skills needed to unite diverse peoples for common defense.`,
        programs: kamiakinPrograms
    },
    'leschi': {
        id: 'leschi',
        name: 'Leschi',
        specialization: 'Coastal Defense & Sacrificial Leadership',
        image: '/assets/images/Leschi.jpg',
        experience: '57+ years',
        category: 'native-american',
        color: '#556B2F',
        secondaryColor: '#C0C0C0',
        intro: `The Nisqually chief who fought to defend his people's homeland in Puget Sound, Leschi ultimately sacrificed his life for his people's rights. His training builds the defensive strength needed to protect sacred homelands and the noble spirit that accepts personal sacrifice for the greater good.`,
        programs: leschiPrograms
    },
    'little-turtle': {
        id: 'little-turtle',
        name: 'Little Turtle',
        specialization: 'Strategic Mastery & Tactical Brilliance',
        image: '/assets/images/Little-Turtle.jpg',
        experience: '74+ years',
        category: 'native-american',
        color: '#228B22',
        secondaryColor: '#C0C0C0',
        intro: `The Miami war chief who was arguably the greatest Native American military strategist, Little Turtle defeated multiple American armies before wisely choosing peace. His training develops the patient strategic thinking and tactical brilliance needed for military genius, plus the wisdom to know when victory becomes impossible.`,
        programs: littleTurtlePrograms
    },
    'osceola': {
        id: 'osceola',
        name: 'Osceola',
        specialization: 'Swamp Warfare & Unconquered Spirit',
        image: '/assets/images/Osceola.jpg',
        experience: '34+ years',
        category: 'native-american',
        color: '#8B0000',
        secondaryColor: '#C0C0C0',
        intro: `The young Seminole leader who turned the Florida Everglades into an impregnable fortress, Osceola mastered swamp warfare and embodied the unconquered spirit. His training develops the specialized conditioning needed for wetland combat and the fierce determination that never accepts defeat or surrender.`,
        programs: osceolaPrograms
    }
};

// Export the data
export default nativeAmericanFourTrainersData;